import { Configuration } from '../../configuration'

export class PagingRequest {
    constructor(configuration: Configuration) {
        this.descending = false;
        this.sortProperty = null;
        this.pageSize = configuration.paging.pageSize;
        this.pageNumber = 0;
    }

    descending: boolean;
    sortProperty: string;
    pageSize: number;
    pageNumber: number;

    equals(other: PagingRequest) {
        return other &&
            this.descending === other.descending &&
            this.sortProperty === other.sortProperty &&
            this.pageSize === other.pageSize &&
            this.pageNumber === other.pageNumber;
    }
}

export interface IPage<T> {
    totalRecords: number;
    totalPages: number;
    data: T[];
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/common/paging.ts